import { render, staticRenderFns } from "./ValueCard.vue?vue&type=template&id=81eae412&scoped=true"
import script from "./ValueCard.vue?vue&type=script&lang=js"
export * from "./ValueCard.vue?vue&type=script&lang=js"
import style0 from "./ValueCard.vue?vue&type=style&index=0&id=81eae412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81eae412",
  null
  
)

export default component.exports